export default __webpack_public_path__ + "static/media/resolucao-anuidade-2020.cee01c1a.pdf";